import { navigate } from "gatsby";
import axios from "../../actions/api";
import React, { useState, useCallback, useEffect } from "react";
// import useWebSocket, { ReadyState } from "react-use-websocket";

const ChatIcon = (props) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [chatList, setChatList] = useState([]);
  const [loading, setLoading] = useState(false);
  // useEffect(() => {
  //   if (chatList.length > 0) {
  //     // Sum of all userUnreadCount in chatList
  //     const sum = chatList.reduce((a, b) => a + (b["userUnreadCount"] || 0), 0);
  //     setUnreadCount(sum);
  //   }
  // }, [chatList]);
  // const { sendMessage, lastMessage, readyState } = useWebSocket(
  //   `${process.env.GATSBY_WS}?token=${btoa(`${JSON.parse(localStorage.getItem("member")).user_id}:user`)}`,
  // );

  // useEffect(() => {
  //   if (lastMessage != null && lastMessage.data) {
  //     const data = JSON.parse(lastMessage.data);
  //     if (data.type === "message") {
  //       setUnreadCount(unreadCount + 1);
  //     }
  //   }
  // }, [lastMessage]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const headers = { "X-API-KEY": process.env.GATSBY_CHAT_API_KEY };
      const response = await axios({
        method: "get",
        headers,
        url: `${process.env.GATSBY_CHAT_API}chats/${JSON.parse(localStorage.getItem("member")).user_id}`,
      });
      const messages = response.data;
      setChatList(messages);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  // const connectionStatus = {
  //   [ReadyState.CONNECTING]: "Connecting",
  //   [ReadyState.OPEN]: "Open",
  //   [ReadyState.CLOSING]: "Closing",
  //   [ReadyState.CLOSED]: "Closed",
  //   [ReadyState.UNINSTANTIATED]: "Uninstantiated",
  // }[readyState];

  // useEffect(() => {
  //   fetchData();
  // }, []);

  return (
    <li class="htc-nav-item">
      <a
        href="javascript:void(0)"
        class="htc-nav-link htc-nav-link-header"
        data-bs-toggle="modal"
        data-bs-target="#chatCollapse"
        onClick={(e) => {
          if (loading) return;
          e.preventDefault();
          navigate("/chats");
        }}
      >
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.5 9.58336C17.5029 10.6832 17.2459 11.7683 16.75 12.75C16.162 13.9265 15.2581 14.916 14.1395 15.6078C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6696 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7683 3.33047 10.6832 3.33333 9.58336C3.33384 8.26815 3.70051 6.97907 4.39227 5.86048C5.08402 4.7419 6.07355 3.838 7.25 3.25002C8.23176 2.75413 9.31678 2.49716 10.4167 2.50002H10.8333C12.5703 2.59585 14.2109 3.32899 15.4409 4.55907C16.671 5.78915 17.4042 7.42973 17.5 9.16669V9.58336Z"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="white"
          ></path>
        </svg>
        {!props.isMobile ? "Messages" : ""}
        {!props?.isMobile && props?.unReadChatCount ? (
          <span class="cart-numbers chat-unread">{props?.unReadChatCount}</span>
        ) : (
          ""
        )}
        {props?.isMobile && props?.unReadChatCount > 0 ? (
          <span class="chats-numbers">{props?.unReadChatCount}</span>
        ) : (
          ""
        )}
      </a>
    </li>
  );
};

export default ChatIcon;
